import React from 'react';

type Props = {color?: string};

export const TipsTabSvg: React.FC<Props> = ({color = '#FF8A71'}) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={50} height={24} fill='none' viewBox='0 0 50 24'>
    <path
      fill={color}
      fillRule='evenodd'
      clipRule='evenodd'
      d='M25 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-1.5 3a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z'
    />
    <path
      fill={color}
      d='M18 14.5c0-1.38 1.12-2.5 2.5-2.5h9c1.38 0 2.5 1.12 2.5 2.5V17H18v-2.5Z'
    />
    <path
      fill={color}
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15 19a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H16a1 1 0 0 1-1-1Z'
    />
  </svg>
);
